module.exports = __webpack_public_path__ + "static/media/inherited.e2f70be4.png";